export const CUSTOMER_CATEGORY_OPTIONS = [
  '跨境电商',
  '国内电商',
  '国内工厂',
  '线下零售',
  '同行',
];

export default CUSTOMER_CATEGORY_OPTIONS;
